export default __webpack_public_path__ + "static/media/5.206de7c0.jpg";